// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const Resource = {
    Dashboard: {
        Name: 'Dashboard',
        Value: 'dashboard',
    },
    Dashboard_GlobalSales: {
        Name: 'Dashboard Global Sales',
        Value: 'dashboard.global_sales',
    },
    Dashboard_AssignedOrganizations: {
        Name: 'Dashboard Assigned Organizations',
        Value: 'dashboard.assigned_organizations',
    },
    Dashboard_AssignedOrganizationSales: {
        Name: 'Dashboard Assigned Organization Sales',
        Value: 'dashboard.assigned_organization_sales',
    },
    Notifications_EmailPendingProductProof: {
        Name: 'Notifications Email Pending Product Proof',
        Value: 'notifications.email_pending_product_proof',
    },
    Notifications_EmailProductProofRejection: {
        Name: 'Notifications Email Product Proof Rejection',
        Value: 'notifications.email_product_proof_rejection',
    },
    Products_Proofs: {
        Name: 'Products Proofs',
        Value: 'products.proofs',
    },
    Products_Orders_View: {
        Name: 'Products Orders View',
        Value: 'products.orders.view',
    },
    Products_Orders_Create: {
        Name: 'Products Orders Create',
        Value: 'products.orders.create',
    },
    Users: {
        Name: 'Users',
        Value: 'users',
    },
    Users_Index: {
        Name: 'Users Index',
        Value: 'users.index',
    },
    Users_Show: {
        Name: 'Users Show',
        Value: 'users.show',
    },
    Users_Manage: {
        Name: 'Users Manage',
        Value: 'users.manage',
    },
    Users_SystemUsers: {
        Name: 'Users System Users',
        Value: 'users.system_users',
    },
    Corporations: {
        Name: 'Corporations',
        Value: 'corporations',
    },
    Corporations_Index: {
        Name: 'Corporations Index',
        Value: 'corporations.index',
    },
    Corporations_Show: {
        Name: 'Corporations Show',
        Value: 'corporations.show',
    },
    Corporations_Manage: {
        Name: 'Corporations Manage',
        Value: 'corporations.manage',
    },
    Corporations_Reports: {
        Name: 'Corporations Reports',
        Value: 'corporations.reports',
    },
    Corporations_Users_Index: {
        Name: 'Corporations Users Index',
        Value: 'corporations.users.index',
    },
    Corporations_Users_Show: {
        Name: 'Corporations Users Show',
        Value: 'corporations.users.show',
    },
    Corporations_Users_Manage: {
        Name: 'Corporations Users Manage',
        Value: 'corporations.users.manage',
    },
    Corporations_Groups: {
        Name: 'Corporations Groups',
        Value: 'corporations.groups',
    },
    Corporations_Groups_Index: {
        Name: 'Corporations Groups Index',
        Value: 'corporations.groups.index',
    },
    Corporations_Products_Proofs: {
        Name: 'Corporations Products Proofs',
        Value: 'corporations.products.proofs',
    },
    Corporations_Settings_Standard: {
        Name: 'Corporations Settings Standard',
        Value: 'corporations.settings.standard',
    },
    Corporations_Settings_Assets: {
        Name: 'Corporations Settings Assets',
        Value: 'corporations.settings.assets',
    },
    Corporations_Settings_AdSlots: {
        Name: 'Corporations Settings Ad Slots',
        Value: 'corporations.settings.ad_slots',
    },
    Corporations_Notifications: {
        Name: 'Corporations Notifications',
        Value: 'corporations.notifications',
    },
    Corporations_Notifications_EmailReportSummary: {
        Name: 'Corporations Notifications Email Report Summary',
        Value: 'corporations.notifications.email_report_summary',
    },
    Corporations_Notifications_AtAGlance: {
        Name: 'Corporations Notifications At A Glance',
        Value: 'corporations.notifications.at_a_glance',
    },
    Corporations_Notifications_EmailPendingProductProof: {
        Name: 'Corporations Notifications Email Pending Product Proof',
        Value: 'corporations.notifications.email_pending_product_proof',
    },
    Corporations_Notifications_EmailProductProofRejection: {
        Name: 'Corporations Notifications Email Product Proof Rejection',
        Value: 'corporations.notifications.email_product_proof_rejection',
    },
    Organizations: {
        Name: 'Organizations',
        Value: 'organizations',
    },
    Organizations_Index: {
        Name: 'Organizations Index',
        Value: 'organizations.index',
    },
    Organizations_Index_Members: {
        Name: 'Organizations Index Members',
        Value: 'organizations.index.members',
    },
    Organizations_Show: {
        Name: 'Organizations Show',
        Value: 'organizations.show',
    },
    Organizations_Manage: {
        Name: 'Organizations Manage',
        Value: 'organizations.manage',
    },
    Settings: {
        Name: 'Settings',
        Value: 'settings',
    },
    Settings_Obituaries: {
        Name: 'Settings Obituaries',
        Value: 'settings.obituaries',
    },
    Settings_Obituaries_CoverPhotos: {
        Name: 'Settings Obituaries Cover Photos',
        Value: 'settings.obituaries.cover_photos',
    },
    Settings_Obituaries_Placeholders: {
        Name: 'Settings Obituaries Placeholders',
        Value: 'settings.obituaries.placeholders',
    },
    Settings_Obituaries_Emblems: {
        Name: 'Settings Obituaries Emblems',
        Value: 'settings.obituaries.emblems',
    },
    Settings_Obituaries_Tracks: {
        Name: 'Settings Obituaries Tracks',
        Value: 'settings.obituaries.tracks',
    },
    Settings_DailyGriefEmails: {
        Name: 'Settings Daily Grief Emails',
        Value: 'settings.daily_grief_emails',
    },
    Internal: {
        Name: 'Internal',
        Value: 'internal',
    },
    LoadBalancers: {
        Name: 'Load Balancers',
        Value: 'load_balancers',
    },
    Audit: {
        Name: 'Audit',
        Value: 'audit',
    },
    Assets: {
        Name: 'Assets',
        Value: 'assets',
    },
    Tickets: {
        Name: 'Tickets',
        Value: 'tickets',
    },
    WebhookReports: {
        Name: 'Webhook Reports',
        Value: 'webhook_reports',
    },
    WhatsNew: {
        Name: 'Whats New',
        Value: 'whats_new',
    },
    WhatsNew_Manage: {
        Name: 'Whats New Manage',
        Value: 'whats_new.manage',
    },
    Documentation: {
        Name: 'Documentation',
        Value: 'documentation',
    },
    CurrentOrganization: {
        Name: 'Current Organization',
        Value: 'current_organization',
    },
    CurrentOrganization_Manage: {
        Name: 'Current Organization Manage',
        Value: 'current_organization.manage',
    },
    CurrentOrganization_Contacts: {
        Name: 'Current Organization Contacts',
        Value: 'current_organization.contacts',
    },
    CurrentOrganization_Contacts_Manage: {
        Name: 'Current Organization Contacts Manage',
        Value: 'current_organization.contacts.manage',
    },
    CurrentOrganization_Florists: {
        Name: 'Current Organization Florists',
        Value: 'current_organization.florists',
    },
    CurrentOrganization_Florists_Manage: {
        Name: 'Current Organization Florists Manage',
        Value: 'current_organization.florists.manage',
    },
    CurrentOrganization_Events: {
        Name: 'Current Organization Events',
        Value: 'current_organization.events',
    },
    CurrentOrganization_Api: {
        Name: 'Current Organization Api',
        Value: 'current_organization.api',
    },
    CurrentOrganization_Integrations: {
        Name: 'Current Organization Integrations',
        Value: 'current_organization.integrations',
    },
    CurrentOrganization_Integrations_Legacy: {
        Name: 'Current Organization Integrations Legacy',
        Value: 'current_organization.integrations.legacy',
    },
    CurrentOrganization_Integrations_FuneralCall: {
        Name: 'Current Organization Integrations Funeral Call',
        Value: 'current_organization.integrations.funeral_call',
    },
    CurrentOrganization_Integrations_Aftercare_Elevated: {
        Name: 'Current Organization Integrations Aftercare Elevated',
        Value: 'current_organization.integrations.aftercare.elevated',
    },
    CurrentOrganization_Notifications: {
        Name: 'Current Organization Notifications',
        Value: 'current_organization.notifications',
    },
    CurrentOrganization_Notifications_EmailEventRegistrations: {
        Name: 'Current Organization Notifications Email Event Registrations',
        Value: 'current_organization.notifications.email_event_registrations',
    },
    CurrentOrganization_Notifications_EmailGuestbookApprovals: {
        Name: 'Current Organization Notifications Email Guestbook Approvals',
        Value: 'current_organization.notifications.email_guestbook_approvals',
    },
    CurrentOrganization_Notifications_EmailContactForms: {
        Name: 'Current Organization Notifications Email Contact Forms',
        Value: 'current_organization.notifications.email_contact_forms',
    },
    CurrentOrganization_Notifications_EmailTestimonials: {
        Name: 'Current Organization Notifications Email Testimonials',
        Value: 'current_organization.notifications.email_testimonials',
    },
    CurrentOrganization_Notifications_EmailPendingProductProof: {
        Name: 'Current Organization Notifications Email Pending Product Proof',
        Value: 'current_organization.notifications.email_pending_product_proof',
    },
    CurrentOrganization_Notifications_EmailProductProofRejection: {
        Name: 'Current Organization Notifications Email Product Proof Rejection',
        Value: 'current_organization.notifications.email_product_proof_rejection',
    },
    CurrentOrganization_Notifications_CampaignDonations: {
        Name: 'Current Organization Notifications Campaign Donations',
        Value: 'current_organization.notifications.campaign_donations',
    },
    CurrentOrganization_Notifications_AtAGlance: {
        Name: 'Current Organization Notifications At A Glance',
        Value: 'current_organization.notifications.at_a_glance',
    },
    CurrentOrganization_Assets: {
        Name: 'Current Organization Assets',
        Value: 'current_organization.assets',
    },
    CurrentOrganization_Settings: {
        Name: 'Current Organization Settings',
        Value: 'current_organization.settings',
    },
    CurrentOrganization_Settings_Standard: {
        Name: 'Current Organization Settings Standard',
        Value: 'current_organization.settings.standard',
    },
    CurrentOrganization_Settings_Elevated: {
        Name: 'Current Organization Settings Elevated',
        Value: 'current_organization.settings.elevated',
    },
    CurrentOrganization_Settings_CodeSnippets: {
        Name: 'Current Organization Settings Code Snippets',
        Value: 'current_organization.settings.code_snippets',
    },
    CurrentOrganization_Settings_Sso: {
        Name: 'Current Organization Settings Sso',
        Value: 'current_organization.settings.sso',
    },
    CurrentOrganization_Settings_Sso_Elevated: {
        Name: 'Current Organization Settings Sso Elevated',
        Value: 'current_organization.settings.sso.elevated',
    },
    CurrentOrganization_Settings_Facebook: {
        Name: 'Current Organization Settings Facebook',
        Value: 'current_organization.settings.facebook',
    },
    CurrentOrganization_Settings_AdSlots: {
        Name: 'Current Organization Settings Ad Slots',
        Value: 'current_organization.settings.ad_slots',
    },
    CurrentOrganization_Settings_Legacy: {
        Name: 'Current Organization Settings Legacy',
        Value: 'current_organization.settings.legacy',
    },
    CurrentOrganization_Dashboard: {
        Name: 'Current Organization Dashboard',
        Value: 'current_organization.dashboard',
    },
    CurrentOrganization_Dashboard_Sales: {
        Name: 'Current Organization Dashboard Sales',
        Value: 'current_organization.dashboard.sales',
    },
    CurrentOrganization_Dashboard_GuestbookApprovals: {
        Name: 'Current Organization Dashboard Guestbook Approvals',
        Value: 'current_organization.dashboard.guestbook_approvals',
    },
    CurrentOrganization_Users: {
        Name: 'Current Organization Users',
        Value: 'current_organization.users',
    },
    CurrentOrganization_Roles: {
        Name: 'Current Organization Roles',
        Value: 'current_organization.roles',
    },
    CurrentOrganization_RelatedOrganizations: {
        Name: 'Current Organization Related Organizations',
        Value: 'current_organization.related_organizations',
    },
    CurrentOrganization_RelatedOrganizations_Manage: {
        Name: 'Current Organization Related Organizations Manage',
        Value: 'current_organization.related_organizations.manage',
    },
    CurrentOrganization_Reports: {
        Name: 'Current Organization Reports',
        Value: 'current_organization.reports',
    },
    CurrentOrganization_LeadGeneration: {
        Name: 'Current Organization Lead Generation',
        Value: 'current_organization.lead_generation',
    },
    CurrentOrganization_Links_WebsiteManager: {
        Name: 'Current Organization Links Website Manager',
        Value: 'current_organization.links.website_manager',
    },
    CurrentOrganization_Links_WebsiteManager_Republish: {
        Name: 'Current Organization Links Website Manager Republish',
        Value: 'current_organization.links.website_manager.republish',
    },
    CurrentOrganization_Links_WebsiteManager_Seo: {
        Name: 'Current Organization Links Website Manager Seo',
        Value: 'current_organization.links.website_manager.seo',
    },
    CurrentOrganization_Links_WebsiteManager_Personalization: {
        Name: 'Current Organization Links Website Manager Personalization',
        Value: 'current_organization.links.website_manager.personalization',
    },
    CurrentOrganization_Links_WebsiteManager_ContentLibrary: {
        Name: 'Current Organization Links Website Manager Content Library',
        Value: 'current_organization.links.website_manager.content_library',
    },
    CurrentOrganization_Links_WebsiteManager_DeveloperMode: {
        Name: 'Current Organization Links Website Manager Developer Mode',
        Value: 'current_organization.links.website_manager.developer_mode',
    },
    CurrentOrganization_Links_PartnerStore: {
        Name: 'Current Organization Links Partner Store',
        Value: 'current_organization.links.partner_store',
    },
    CurrentOrganization_Audience: {
        Name: 'Current Organization Audience',
        Value: 'current_organization.audience',
    },
    CurrentOrganization_WebsiteContent: {
        Name: 'Current Organization Website Content',
        Value: 'current_organization.website_content',
    },
    CurrentOrganization_ExportData: {
        Name: 'Current Organization Export Data',
        Value: 'current_organization.export_data',
    },
    CurrentOrganization_Domains: {
        Name: 'Current Organization Domains',
        Value: 'current_organization.domains',
    },
    CurrentOrganization_Domains_Manage: {
        Name: 'Current Organization Domains Manage',
        Value: 'current_organization.domains.manage',
    },
    CurrentOrganization_Domains_LoadBalancer: {
        Name: 'Current Organization Domains Load Balancer',
        Value: 'current_organization.domains.load_balancer',
    },
    CurrentOrganization_Redirects: {
        Name: 'Current Organization Redirects',
        Value: 'current_organization.redirects',
    },
    CurrentOrganization_Payments: {
        Name: 'Current Organization Payments',
        Value: 'current_organization.payments',
    },
    CurrentOrganization_Payments_Manage: {
        Name: 'Current Organization Payments Manage',
        Value: 'current_organization.payments.manage',
    },
    CurrentOrganization_Locations: {
        Name: 'Current Organization Locations',
        Value: 'current_organization.locations',
    },
    CurrentOrganization_Locations_Index: {
        Name: 'Current Organization Locations Index',
        Value: 'current_organization.locations.index',
    },
    CurrentOrganization_Locations_Primary_Create: {
        Name: 'Current Organization Locations Primary Create',
        Value: 'current_organization.locations.primary.create',
    },
    CurrentOrganization_Locations_Primary_Update: {
        Name: 'Current Organization Locations Primary Update',
        Value: 'current_organization.locations.primary.update',
    },
    CurrentOrganization_Locations_Primary_Update_Elevated: {
        Name: 'Current Organization Locations Primary Update Elevated',
        Value: 'current_organization.locations.primary.update.elevated',
    },
    CurrentOrganization_Locations_Primary_Delete: {
        Name: 'Current Organization Locations Primary Delete',
        Value: 'current_organization.locations.primary.delete',
    },
    CurrentOrganization_Products_Proofs: {
        Name: 'Current Organization Products Proofs',
        Value: 'current_organization.products.proofs',
    },
    Obituaries: {
        Name: 'Obituaries',
        Value: 'obituaries',
    },
    Obituaries_Index: {
        Name: 'Obituaries Index',
        Value: 'obituaries.index',
    },
    Obituaries_Show: {
        Name: 'Obituaries Show',
        Value: 'obituaries.show',
    },
    Obituaries_Manage: {
        Name: 'Obituaries Manage',
        Value: 'obituaries.manage',
    },
    Obituary: {
        Name: 'Obituary',
        Value: 'obituary',
    },
    Obituary_Manage: {
        Name: 'Obituary Manage',
        Value: 'obituary.manage',
    },
    Obituary_Show_NextSteps: {
        Name: 'Obituary Show Next Steps',
        Value: 'obituary.show.next_steps',
    },
    Obituary_Publish: {
        Name: 'Obituary Publish',
        Value: 'obituary.publish',
    },
    Obituary_Photo_Cover: {
        Name: 'Obituary Photo Cover',
        Value: 'obituary.photo.cover',
    },
    Obituary_Photo_Cover_Manage: {
        Name: 'Obituary Photo Cover Manage',
        Value: 'obituary.photo.cover.manage',
    },
    Obituary_Photo_Profile: {
        Name: 'Obituary Photo Profile',
        Value: 'obituary.photo.profile',
    },
    Obituary_Photo_Emblem: {
        Name: 'Obituary Photo Emblem',
        Value: 'obituary.photo.emblem',
    },
    Obituary_ObituaryText: {
        Name: 'Obituary Obituary Text',
        Value: 'obituary.obituary_text',
    },
    Obituary_ObituaryText_AiObituaryWriter: {
        Name: 'Obituary Obituary Text Ai Obituary Writer',
        Value: 'obituary.obituary_text.ai_obituary_writer',
    },
    Obituary_ObituaryText_BackgroundPhoto: {
        Name: 'Obituary Obituary Text Background Photo',
        Value: 'obituary.obituary_text.background_photo',
    },
    Obituary_ObituaryText_FontFamily: {
        Name: 'Obituary Obituary Text Font Family',
        Value: 'obituary.obituary_text.font_family',
    },
    Obituary_ObituaryText_FontSize: {
        Name: 'Obituary Obituary Text Font Size',
        Value: 'obituary.obituary_text.font_size',
    },
    Obituary_ObituaryText_TextColor: {
        Name: 'Obituary Obituary Text Text Color',
        Value: 'obituary.obituary_text.text_color',
    },
    Obituary_ObituaryText_BackgroundColor: {
        Name: 'Obituary Obituary Text Background Color',
        Value: 'obituary.obituary_text.background_color',
    },
    Obituary_ObituaryText_ParagraphFormat: {
        Name: 'Obituary Obituary Text Paragraph Format',
        Value: 'obituary.obituary_text.paragraph_format',
    },
    Obituary_ObituaryText_ParagraphStyle: {
        Name: 'Obituary Obituary Text Paragraph Style',
        Value: 'obituary.obituary_text.paragraph_style',
    },
    Obituary_ObituaryText_InsertLink: {
        Name: 'Obituary Obituary Text Insert Link',
        Value: 'obituary.obituary_text.insert_link',
    },
    Obituary_ObituaryText_InsertTable: {
        Name: 'Obituary Obituary Text Insert Table',
        Value: 'obituary.obituary_text.insert_table',
    },
    Obituary_Media: {
        Name: 'Obituary Media',
        Value: 'obituary.media',
    },
    Obituary_Media_Videos: {
        Name: 'Obituary Media Videos',
        Value: 'obituary.media.videos',
    },
    Obituary_Media_Videos_Tukios: {
        Name: 'Obituary Media Videos Tukios',
        Value: 'obituary.media.videos.tukios',
    },
    Obituary_Media_Gallery: {
        Name: 'Obituary Media Gallery',
        Value: 'obituary.media.gallery',
    },
    Obituary_Media_Music: {
        Name: 'Obituary Media Music',
        Value: 'obituary.media.music',
    },
    Obituary_Media_CodeSnippets: {
        Name: 'Obituary Media Code Snippets',
        Value: 'obituary.media.code_snippets',
    },
    Obituary_Media_Recordings: {
        Name: 'Obituary Media Recordings',
        Value: 'obituary.media.recordings',
    },
    Obituary_Media_Programs: {
        Name: 'Obituary Media Programs',
        Value: 'obituary.media.programs',
    },
    Obituary_Media_EnhancedAssets: {
        Name: 'Obituary Media Enhanced Assets',
        Value: 'obituary.media.enhanced_assets',
    },
    Obituary_Services: {
        Name: 'Obituary Services',
        Value: 'obituary.services',
    },
    Obituary_Services_Manage: {
        Name: 'Obituary Services Manage',
        Value: 'obituary.services.manage',
    },
    Obituary_Users: {
        Name: 'Obituary Users',
        Value: 'obituary.users',
    },
    Obituary_Users_Manage: {
        Name: 'Obituary Users Manage',
        Value: 'obituary.users.manage',
    },
    Obituary_Charities: {
        Name: 'Obituary Charities',
        Value: 'obituary.charities',
    },
    Obituary_Campaigns: {
        Name: 'Obituary Campaigns',
        Value: 'obituary.campaigns',
    },
    Obituary_Guestbook: {
        Name: 'Obituary Guestbook',
        Value: 'obituary.guestbook',
    },
    Obituary_Guestbook_Manage: {
        Name: 'Obituary Guestbook Manage',
        Value: 'obituary.guestbook.manage',
    },
    Obituary_Guestbook_Subscriptions: {
        Name: 'Obituary Guestbook Subscriptions',
        Value: 'obituary.guestbook.subscriptions',
    },
    Obituary_Products_Proofs: {
        Name: 'Obituary Products Proofs',
        Value: 'obituary.products.proofs',
    },
    Obituary_Products_Manage: {
        Name: 'Obituary Products Manage',
        Value: 'obituary.products.manage',
    },
    Obituary_Settings: {
        Name: 'Obituary Settings',
        Value: 'obituary.settings',
    },
    Obituary_Settings_Create: {
        Name: 'Obituary Settings Create',
        Value: 'obituary.settings.create',
    },
    Obituary_Settings_Elevated: {
        Name: 'Obituary Settings Elevated',
        Value: 'obituary.settings.elevated',
    },
    Obituary_Notifications_EmailGuestbookApprovals: {
        Name: 'Obituary Notifications Email Guestbook Approvals',
        Value: 'obituary.notifications.email_guestbook_approvals',
    },
    Obituary_Notifications_EmailPendingProductProof: {
        Name: 'Obituary Notifications Email Pending Product Proof',
        Value: 'obituary.notifications.email_pending_product_proof',
    },
    Obituary_Notifications_EmailProductProofRejection: {
        Name: 'Obituary Notifications Email Product Proof Rejection',
        Value: 'obituary.notifications.email_product_proof_rejection',
    },
    Obituary_Events: {
        Name: 'Obituary Events',
        Value: 'obituary.events',
    },
    SiteBuilder_Users_Index: {
        Name: 'Site Builder Users Index',
        Value: 'site-builder.users.index',
    },
    SiteBuilder_Organizations_AssignUser: {
        Name: 'Site Builder Organizations Assign User',
        Value: 'site-builder.organizations.assign_user',
    },
    SiteBuilder_Duda_GetTemplates: {
        Name: 'Site Builder Duda Get Templates',
        Value: 'site-builder.duda.get_templates',
    },
    SiteBuilder_Duda_CreateDudaProject: {
        Name: 'Site Builder Duda Create Duda Project',
        Value: 'site-builder.duda.create_duda_project',
    },
    SiteBuilder_Duda_ListPages: {
        Name: 'Site Builder Duda List Pages',
        Value: 'site-builder.duda.list_pages',
    },
    SiteBuilder_Duda_GetSiteContent: {
        Name: 'Site Builder Duda Get Site Content',
        Value: 'site-builder.duda.get_site_content',
    },
    SiteBuilder_Duda_GetSite: {
        Name: 'Site Builder Duda Get Site',
        Value: 'site-builder.duda.get_site',
    },
    SiteBuilder_Organizations_Index: {
        Name: 'Site Builder Organizations Index',
        Value: 'site-builder.organizations.index',
    },
    SiteBuilder_View_LaunchSchedule: {
        Name: 'Site Builder View Launch Schedule',
        Value: 'site-builder.view.launch_schedule',
    },
    SiteBuilder_View_LaunchDate: {
        Name: 'Site Builder View Launch Date',
        Value: 'site-builder.view.launch_date',
    },
    SiteBuilder_View_ProjectedLaunch: {
        Name: 'Site Builder View Projected Launch',
        Value: 'site-builder.view.projected_launch',
    },
    SiteBuilder_Organizations_Launch: {
        Name: 'Site Builder Organizations Launch',
        Value: 'site-builder.organizations.launch',
    },
    SiteBuilder_Organizations_RescheduleLaunch: {
        Name: 'Site Builder Organizations Reschedule Launch',
        Value: 'site-builder.organizations.reschedule_launch',
    },
    SiteBuilder_Organizations_UnscheduleLaunch: {
        Name: 'Site Builder Organizations Unschedule Launch',
        Value: 'site-builder.organizations.unschedule_launch',
    },
    SiteBuilder_SiteMenu: {
        Name: 'Site Builder Site Menu',
        Value: 'site-builder.site_menu',
    },
    SiteBuilder_SiteMenu_DeleteTestSite: {
        Name: 'Site Builder Site Menu Delete Test Site',
        Value: 'site-builder.site_menu.delete_test_site',
    },
    SiteBuilder_SiteMenu_OpenEditor: {
        Name: 'Site Builder Site Menu Open Editor',
        Value: 'site-builder.site_menu.open_editor',
    },
    SiteBuilder_SiteMenu_ViewPreview: {
        Name: 'Site Builder Site Menu View Preview',
        Value: 'site-builder.site_menu.view_preview',
    },
    SiteBuilder_Organizations_Show: {
        Name: 'Site Builder Organizations Show',
        Value: 'site-builder.organizations.show',
    },
    SiteBuilder_Activity_Show: {
        Name: 'Site Builder Activity Show',
        Value: 'site-builder.activity.show',
    },
    SiteBuilder_Activity_Store: {
        Name: 'Site Builder Activity Store',
        Value: 'site-builder.activity.store',
    },
    SiteBuilder_Organizations_UpdateOrganizationPartnerInfo: {
        Name: 'Site Builder Organizations Update Organization Partner Info',
        Value: 'site-builder.organizations.update_organization_partner_info',
    },
    SiteBuilder_View_Domains: {
        Name: 'Site Builder View Domains',
        Value: 'site-builder.view.domains',
    },
    SiteBuilder_View_Domains_DomainRequest_EditAeEmail: {
        Name: 'Site Builder View Domains Domain Request Edit Ae Email',
        Value: 'site-builder.view.domains.domain_request.edit_ae_email',
    },
    SiteBuilder_Domains_Email: {
        Name: 'Site Builder Domains Email',
        Value: 'site-builder.domains.email',
    },
    SiteBuilder_Domains_Proxy: {
        Name: 'Site Builder Domains Proxy',
        Value: 'site-builder.domains.proxy',
    },
    SiteBuilder_Domains_Delete: {
        Name: 'Site Builder Domains Delete',
        Value: 'site-builder.domains.delete',
    },
    SiteBuilder_View_SiteHeader: {
        Name: 'Site Builder View Site Header',
        Value: 'site-builder.view.site_header',
    },
    SiteBuilder_Organizations_UpdateTemplate: {
        Name: 'Site Builder Organizations Update Template',
        Value: 'site-builder.organizations.update_template',
    },
    SiteBuilder_SiteHeader_EditSite: {
        Name: 'Site Builder Site Header Edit Site',
        Value: 'site-builder.site_header.edit_site',
    },
    SiteBuilder_SiteHeader_PreviewSite: {
        Name: 'Site Builder Site Header Preview Site',
        Value: 'site-builder.site_header.preview_site',
    },
    SiteBuilder_SiteHeader_VisitSite: {
        Name: 'Site Builder Site Header Visit Site',
        Value: 'site-builder.site_header.visit_site',
    },
    SiteBuilder_View_MySitesTable: {
        Name: 'Site Builder View My Sites Table',
        Value: 'site-builder.view.my_sites_table',
    },
    SiteBuilder_Users_SiteStats: {
        Name: 'Site Builder Users Site Stats',
        Value: 'site-builder.users.site_stats',
    },
    SiteBuilder_View_MySitesTable_Filter_Designer: {
        Name: 'Site Builder View My Sites Table Filter Designer',
        Value: 'site-builder.view.my_sites_table.filter.designer',
    },
    SiteBuilder_View_MySitesTable_Filter_AccountExecutive: {
        Name: 'Site Builder View My Sites Table Filter Account Executive',
        Value: 'site-builder.view.my_sites_table.filter.account_executive',
    },
    SiteBuilder_View_MySitesTable_Filter_AccountManager: {
        Name: 'Site Builder View My Sites Table Filter Account Manager',
        Value: 'site-builder.view.my_sites_table.filter.account_manager',
    },
    SiteBuilder_View_MySitesTable_Filter_Floral: {
        Name: 'Site Builder View My Sites Table Filter Floral',
        Value: 'site-builder.view.my_sites_table.filter.floral',
    },
    SiteBuilder_View_MySitesTable_Filter_Sales: {
        Name: 'Site Builder View My Sites Table Filter Sales',
        Value: 'site-builder.view.my_sites_table.filter.sales',
    },
    SiteBuilder_View_MySitesTable_Filter_Qa: {
        Name: 'Site Builder View My Sites Table Filter Qa',
        Value: 'site-builder.view.my_sites_table.filter.qa',
    },
    SiteBuilder_Checklist_Index: {
        Name: 'Site Builder Checklist Index',
        Value: 'site-builder.checklist.index',
    },
    SiteBuilder_Checklist_Elevated: {
        Name: 'Site Builder Checklist Elevated',
        Value: 'site-builder.checklist.elevated',
    },
    SiteBuilder_View_Checklist_Launch: {
        Name: 'Site Builder View Checklist Launch',
        Value: 'site-builder.view.checklist.launch',
    },
    SiteBuilder_Checklist_Launch_Elevated: {
        Name: 'Site Builder Checklist Launch Elevated',
        Value: 'site-builder.checklist.launch.elevated',
    },
    SiteBuilder_View_Checklist_Account: {
        Name: 'Site Builder View Checklist Account',
        Value: 'site-builder.view.checklist.account',
    },
    SiteBuilder_Checklist_Account_Elevated: {
        Name: 'Site Builder Checklist Account Elevated',
        Value: 'site-builder.checklist.account.elevated',
    },
    SiteBuilder_View_Checklist_Designer: {
        Name: 'Site Builder View Checklist Designer',
        Value: 'site-builder.view.checklist.designer',
    },
    SiteBuilder_Checklist_Designer_Elevated: {
        Name: 'Site Builder Checklist Designer Elevated',
        Value: 'site-builder.checklist.designer.elevated',
    },
    SiteBuilder_View_Checklist_Floral: {
        Name: 'Site Builder View Checklist Floral',
        Value: 'site-builder.view.checklist.floral',
    },
    SiteBuilder_Checklist_Floral_Elevated: {
        Name: 'Site Builder Checklist Floral Elevated',
        Value: 'site-builder.checklist.floral.elevated',
    },
    SiteBuilder_Notes_Launch_Elevated: {
        Name: 'Site Builder Notes Launch Elevated',
        Value: 'site-builder.notes.launch.elevated',
    },
    SiteBuilder_Checklist_QualityAssuance_Elevated: {
        Name: 'Site Builder Checklist Quality Assuance Elevated',
        Value: 'site-builder.checklist.quality_assuance.elevated',
    },
    SiteBuilder_Notes_Index: {
        Name: 'Site Builder Notes Index',
        Value: 'site-builder.notes.index',
    },
    SiteBuilder_Notes_Update: {
        Name: 'Site Builder Notes Update',
        Value: 'site-builder.notes.update',
    },
    SiteBuilder_Notes_Destroy: {
        Name: 'Site Builder Notes Destroy',
        Value: 'site-builder.notes.destroy',
    },
    SiteBuilder_Notes_Store: {
        Name: 'Site Builder Notes Store',
        Value: 'site-builder.notes.store',
    },
    SiteBuilder_View_Notes_Launch: {
        Name: 'Site Builder View Notes Launch',
        Value: 'site-builder.view.notes.launch',
    },
    SitebuilderNotes_Launch_Elevated: {
        Name: 'Sitebuilder Notes Launch Elevated',
        Value: 'sitebuilder_notes.launch.elevated',
    },
    SiteBuilder_View_Notes_AccountExecutive: {
        Name: 'Site Builder View Notes Account Executive',
        Value: 'site-builder.view.notes.account_executive',
    },
    SiteBuilder_Notes_AccountExecutive_Elevated: {
        Name: 'Site Builder Notes Account Executive Elevated',
        Value: 'site-builder.notes.account_executive.elevated',
    },
    SiteBuilder_View_Notes_AccountManager: {
        Name: 'Site Builder View Notes Account Manager',
        Value: 'site-builder.view.notes.account_manager',
    },
    SiteBuilder_Notes_AccountManager_Elevated: {
        Name: 'Site Builder Notes Account Manager Elevated',
        Value: 'site-builder.notes.account_manager.elevated',
    },
    SiteBuilder_View_Notes_Designer: {
        Name: 'Site Builder View Notes Designer',
        Value: 'site-builder.view.notes.designer',
    },
    SiteBuilder_Notes_Designer_Elevated: {
        Name: 'Site Builder Notes Designer Elevated',
        Value: 'site-builder.notes.designer.elevated',
    },
    SiteBuilder_View_Notes_Floral: {
        Name: 'Site Builder View Notes Floral',
        Value: 'site-builder.view.notes.floral',
    },
    SiteBuilder_Notes_Floral_Elevated: {
        Name: 'Site Builder Notes Floral Elevated',
        Value: 'site-builder.notes.floral.elevated',
    },
    SiteBuilder_View_Notes_QualityAssuance: {
        Name: 'Site Builder View Notes Quality Assuance',
        Value: 'site-builder.view.notes.quality_assuance',
    },
    SiteBuilder_Notes_QualityAssuance_Elevated: {
        Name: 'Site Builder Notes Quality Assuance Elevated',
        Value: 'site-builder.notes.quality_assuance.elevated',
    },
    SiteBuilder_Revisions_Index: {
        Name: 'Site Builder Revisions Index',
        Value: 'site-builder.revisions.index',
    },
    SiteBuilder_Revisions_Show: {
        Name: 'Site Builder Revisions Show',
        Value: 'site-builder.revisions.show',
    },
    SiteBuilder_Revisions_Update: {
        Name: 'Site Builder Revisions Update',
        Value: 'site-builder.revisions.update',
    },
    SiteBuilder_Revisions_Store: {
        Name: 'Site Builder Revisions Store',
        Value: 'site-builder.revisions.store',
    },
    SiteBuilder_Revisions_Destroy: {
        Name: 'Site Builder Revisions Destroy',
        Value: 'site-builder.revisions.destroy',
    },
    SiteBuilder_WebsiteRevisions_Fixed: {
        Name: 'Site Builder Website Revisions Fixed',
        Value: 'site-builder.website_revisions.fixed',
    },
    SiteBuilder_WebsiteRevisions_Verified: {
        Name: 'Site Builder Website Revisions Verified',
        Value: 'site-builder.website_revisions.verified',
    },
    SiteBuilder_Addons_Index: {
        Name: 'Site Builder Addons Index',
        Value: 'site-builder.addons.index',
    },
    SiteBuilder_Addons_Store: {
        Name: 'Site Builder Addons Store',
        Value: 'site-builder.addons.store',
    },
    SiteBuilder_Organizations_Create: {
        Name: 'Site Builder Organizations Create',
        Value: 'site-builder.organizations.create',
    },
    SiteBuilder_Organizations_CreateOrganization: {
        Name: 'Site Builder Organizations Create Organization',
        Value: 'site-builder.organizations.create_organization',
    },
    SiteBuilder_Organizations_UploadAsset: {
        Name: 'Site Builder Organizations Upload Asset',
        Value: 'site-builder.organizations.upload_asset',
    },
    SiteBuilder_Organizations_TemplateFromExisting: {
        Name: 'Site Builder Organizations Template From Existing',
        Value: 'site-builder.organizations.template_from_existing',
    },
    SiteBuilder_Organizations_MarkCoached: {
        Name: 'Site Builder Organizations Mark Coached',
        Value: 'site-builder.organizations.mark_coached',
    },
    SiteBuilder_View_ReadyForCoaching: {
        Name: 'Site Builder View Ready For Coaching',
        Value: 'site-builder.view.ready_for_coaching',
    },
    SiteBuilder_View_ReadyForCoaching_Assign: {
        Name: 'Site Builder View Ready For Coaching Assign',
        Value: 'site-builder.view.ready_for_coaching.assign',
    },
    SiteBuilder_View_ReadyForCoaching_AssignSelf: {
        Name: 'Site Builder View Ready For Coaching Assign Self',
        Value: 'site-builder.view.ready_for_coaching.assign_self',
    },
    SiteBuilder_View_ReadyForDesignerTable: {
        Name: 'Site Builder View Ready For Designer Table',
        Value: 'site-builder.view.ready_for_designer_table',
    },
    SiteBuilder_View_ReadyForDesigner_Assign: {
        Name: 'Site Builder View Ready For Designer Assign',
        Value: 'site-builder.view.ready_for_designer.assign',
    },
    SiteBuilder_View_ReadyForDesigner_AssignSelf: {
        Name: 'Site Builder View Ready For Designer Assign Self',
        Value: 'site-builder.view.ready_for_designer.assign_self',
    },
    SiteBuilder_View_ReadyForFloralTable: {
        Name: 'Site Builder View Ready For Floral Table',
        Value: 'site-builder.view.ready_for_floral_table',
    },
    SiteBuilder_View_ReadyForFloral_Assign: {
        Name: 'Site Builder View Ready For Floral Assign',
        Value: 'site-builder.view.ready_for_floral.assign',
    },
    SiteBuilder_View_ReadyForFloral_AssignSelf: {
        Name: 'Site Builder View Ready For Floral Assign Self',
        Value: 'site-builder.view.ready_for_floral.assign_self',
    },
    SiteBuilder_View_ReadyForQaTable: {
        Name: 'Site Builder View Ready For Qa Table',
        Value: 'site-builder.view.ready_for_qa_table',
    },
    SiteBuilder_View_ReadyForQa_Assign: {
        Name: 'Site Builder View Ready For Qa Assign',
        Value: 'site-builder.view.ready_for_qa.assign',
    },
    SiteBuilder_View_ReadyForQa_AssignSelf: {
        Name: 'Site Builder View Ready For Qa Assign Self',
        Value: 'site-builder.view.ready_for_qa.assign_self',
    },
    SiteBuilder_GetOrganizationAssignments: {
        Name: 'Site Builder Get Organization Assignments',
        Value: 'site-builder.get_organization_assignments',
    },
    SiteBuilder_View_ScrapesTable: {
        Name: 'Site Builder View Scrapes Table',
        Value: 'site-builder.view.scrapes_table',
    },
    SiteBuilder_Scrape_MarkComplete: {
        Name: 'Site Builder Scrape Mark Complete',
        Value: 'site-builder.scrape.mark_complete',
    },
    SiteBuilder_Scrape_RequestScrape: {
        Name: 'Site Builder Scrape Request Scrape',
        Value: 'site-builder.scrape.request_scrape',
    },
    SiteBuilder_Scrape_StartScrape: {
        Name: 'Site Builder Scrape Start Scrape',
        Value: 'site-builder.scrape.start_scrape',
    },
    SiteBuilder_Scrape_GetScrapeRequests: {
        Name: 'Site Builder Scrape Get Scrape Requests',
        Value: 'site-builder.scrape.get_scrape_requests',
    },
    SiteBuilder_Seo: {
        Name: 'Site Builder Seo',
        Value: 'site-builder.seo',
    },
    SiteBuilder_Seo_GetNumberOfPresetsUsedPerCity: {
        Name: 'Site Builder Seo Get Number Of Presets Used Per City',
        Value: 'site-builder.seo.get_number_of_presets_used_per_city',
    },
    SiteBuilder_Seo_GenerateSitePagesMetaData: {
        Name: 'Site Builder Seo Generate Site Pages Meta Data',
        Value: 'site-builder.seo.generate_site_pages_meta_data',
    },
    SiteBuilder_Seo_UpdateSitePageCustomMetaData: {
        Name: 'Site Builder Seo Update Site Page Custom Meta Data',
        Value: 'site-builder.seo.update_site_page_custom_meta_data',
    },
    SiteBuilder_Seo_Ai_GeneratePageDescriptionMetaData: {
        Name: 'Site Builder Seo Ai Generate Page Description Meta Data',
        Value: 'site-builder.seo.ai.generate_page_description_meta_data',
    },
    SiteBuilder_Organizations_UpdateOrganizationStatus: {
        Name: 'Site Builder Organizations Update Organization Status',
        Value: 'site-builder.organizations.update_organization_status',
    },
    SiteBuilder_Organizations_View_UpdateOrganizationStatus_Elevated: {
        Name: 'Site Builder Organizations View Update Organization Status Elevated',
        Value: 'site-builder.organizations.view.update_organization_status.elevated',
    },
    SiteBuilder_Organizations_View_UpdateOrganizationStatus_Design: {
        Name: 'Site Builder Organizations View Update Organization Status Design',
        Value: 'site-builder.organizations.view.update_organization_status.design',
    },
    SiteBuilder_Organizations_View_UpdateOrganizationStatus_Qa: {
        Name: 'Site Builder Organizations View Update Organization Status Qa',
        Value: 'site-builder.organizations.view.update_organization_status.qa',
    },
    SiteBuilder_Organizations_View_UpdateOrganizationStatus_Ae: {
        Name: 'Site Builder Organizations View Update Organization Status Ae',
        Value: 'site-builder.organizations.view.update_organization_status.ae',
    },
    SiteBuilder_Organizations_View_UpdateOrganizationStatus_Launch: {
        Name: 'Site Builder Organizations View Update Organization Status Launch',
        Value: 'site-builder.organizations.view.update_organization_status.launch',
    },
    SiteBuilder_Organizations_LaunchRedesign: {
        Name: 'Site Builder Organizations Launch Redesign',
        Value: 'site-builder.organizations.launch_redesign',
    },
    SiteBuilder_Assets_GetAssets: {
        Name: 'Site Builder Assets Get Assets',
        Value: 'site-builder.assets.get_assets',
    },
    SiteBuilder_Assets_UploadAssets: {
        Name: 'Site Builder Assets Upload Assets',
        Value: 'site-builder.assets.upload_assets',
    },
    SiteBuilder_Assets_DownloadAssets: {
        Name: 'Site Builder Assets Download Assets',
        Value: 'site-builder.assets.download_assets',
    },
    SiteBuilder_Assets_DeleteAsset: {
        Name: 'Site Builder Assets Delete Asset',
        Value: 'site-builder.assets.delete_asset',
    },
}